import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { APP_VERSION, SHOW_FOOTER_VERSION } from "@/version";

export function Footer() {
  return (
    <footer className="bg-navy text-mortar mt-auto" data-testid="footer">
      <div className="container-mtr py-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-3">
          <Logo variant="dark" to={null} />
          <p className="text-[14px] max-w-xs">
            Accurate aerial roof measurement reports for roofing contractors across the United States.
          </p>
        </div>
        <div>
          <h2 className="text-white font-bold text-[15px] mb-3">Product</h2>
          <ul className="space-y-2 text-[14px]">
            <li><Link to="/signup" className="hover:text-white" data-testid="footer-signup">Get started</Link></li>
            <li><Link to="/sample-report" className="hover:text-white" data-testid="footer-sample">Sample report</Link></li>
            <li><Link to="/login" className="hover:text-white" data-testid="footer-login">Log in</Link></li>
            <li><Link to="/#how-it-works" className="hover:text-white">How it works</Link></li>
            <li><Link to="/#pricing" className="hover:text-white">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <h2 className="text-white font-bold text-[15px] mb-3">Legal</h2>
          <ul className="space-y-2 text-[14px]">
            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/cookie-policy" className="hover:text-white" data-testid="footer-cookie-policy">Cookie Policy</Link></li>
            <li>
              <button
                className="hover:text-white text-left"
                data-testid="footer-do-not-sell"
                onClick={() => window.dispatchEvent(new CustomEvent("open-cookie-settings"))}
              >
                Do Not Sell or Share My Info
              </button>
            </li>
          </ul>
        </div>
        <div>
          <h2 className="text-white font-bold text-[15px] mb-3">Company</h2>
          <ul className="space-y-2 text-[14px]">
            <li><a href="mailto:support@measuretheroof.com" className="hover:text-white" data-testid="footer-support">Contact support</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-mtr py-5 text-[13px] flex flex-col sm:flex-row gap-2 justify-between items-center">
          <span>© {new Date().getFullYear()} MeasureTheRoof. All rights reserved.</span>
          <div className="flex items-center gap-3">
            {SHOW_FOOTER_VERSION && (
              <span data-testid="footer-version" className="inline-flex items-center gap-1.5">
                <span className="text-[10px] font-extrabold uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-orange/20 text-orange leading-none">Beta</span>
                v{APP_VERSION}
              </span>
            )}
            <span>Made for US roofing contractors.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
